import './style.scss';

// Import dependencies
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Initialize scroll animations
const scrollInit = (cmpnt, scroller) => {
  const animDefaults = {
    ease: 'none',
  };

  const endCalc = (inertia = 1) => {
    const galleryItems = scroller.children;
    const galleryItemsWidths = Array.from(galleryItems).map(
      item => item.offsetWidth,
    );
    const galleryItemsWidthTotal = galleryItemsWidths.reduce(
      (a, b) => a + b,
      0,
    );
    const gap = window.getComputedStyle(scroller).getPropertyValue('gap');
    const gapTotal = gap.split('px')[0] * (galleryItems.length - 1);
    const calc = (galleryItemsWidthTotal + gapTotal) / inertia;
    const distance = `${calc}px`;
    return `${distance} center`;
  };

  const main = gsap.timeline({
    scrollTrigger: {
      trigger: cmpnt,
      start: 'center center',
      // end: () => endCalc(7),
      end: 'bottom+=100px center',
      pin: document.querySelector('main'),
      scrub: 0.7,
      // markers: true,
    },
  });

  main
    .to(
      scroller,
      {
        x: `-100%`,
        ...animDefaults,
      },
      'start',
    )
    .to(
      scroller.parentElement,
      {
        x: '100%',
        ...animDefaults,
      },
      'start',
    );

  return () => {
    main.scrollTrigger.kill();
    main.kill();
  };
};

const waitForImages = (element, callback) => {
  const images = element.querySelectorAll('img');
  let loadedImages = 0;
  const totalImages = images.length;

  const checkAllImagesLoaded = () => {
    loadedImages++;
    if (loadedImages === totalImages) {
      callback();
    }
  };

  if (totalImages === 0) {
    callback();
  } else {
    images.forEach(() => {
      checkAllImagesLoaded();
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const all = document.querySelectorAll('.gallery_scroll');
  all.forEach(cmpnt => {
    if (cmpnt) {
      const scroller = cmpnt.querySelector('.gallery_scroll-gallery');
      waitForImages(scroller, () => scrollInit(cmpnt, scroller));
      // scrollInit(cmpnt, scroller);
    }
  });
});
